const getContents = (action) => action.entities.contents;

export default function contentsReducer(state = {}, action) {
  switch (action.type) {
    case "CONTENTS_FETCHED":
      return { ...state, ...getContents(action) };
    default:
      return state;
  }
}
